import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'jalali-moment';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const SignalCommentsList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('signal_comments'), link: '/signal-comments-list' },
		{ title: t('list') },
	];

	const [signalComments, setSignalComments] = useState([]);
	let signalCommentsListData = {
		head: [t('creation_date'), t('analyser'), t('signal'), t('comment'), t('operation')],
		body: signalComments.map(signalComment => [
			moment(signalComment.create_date.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD'),
			<Link className='' to={`/users-edit/${signalComment.user_id_information.user_id}`} target="_blank">
				{signalComment.user_id_information.user_fullname}
			</Link>,
			<Link className='' to={`/signals-edit/${signalComment.signal_id_information.signal_id}`} target="_blank">
				{t('view')} {t('signal')}
			</Link>,
			signalComment.signalcomment_information.title + ': ' + signalComment.signalcomment_information.description,
			<Link className='btn btn-secondary btn-sm p-1' to={`/signal-comments-edit/${signalComment.signalcomment_id}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['ltr', 'rtl', 'rtl', 'ltr']
	};
	
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getSignalComments = async () => {
		let body = {
			signal_id: null,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/signalcomments/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_signalcomments);
				setSignalComments(response.data.signalcomments);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getSignalComments();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<ListTable title={t('signal_comments')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={signalCommentsListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default SignalCommentsList;
